import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalModule, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ValidationFormAnswerModalComponent } from 'src/app/profile-details/components/validation-form-answer-modal/validation-form-answer-modal.component';
import { ModalService } from 'src/app/core/modal/modal.service';
import { ValidationFormApiService } from 'src/app/core/api/validation-form-api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-shared-validation-form',
  standalone: true,
  imports: [NgbModalModule],
  templateUrl: './shared-validation-form.component.html',
  styleUrl: './shared-validation-form.component.scss'
})
export class SharedValidationFormComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private modalService: ModalService,
    private validationFormApiService: ValidationFormApiService,
    private router: Router,
  ) {}

  ngOnInit() {
    const token = this.route.snapshot.queryParams['token'];
    if (!token) {
      this.router.navigate(['/login']);
    }

    this.validationFormApiService.getAccessToken(token).subscribe((accessToken) => {
      const validationFormId = accessToken.validationFormId;

      this.validationFormApiService.getValidationFormById(validationFormId).subscribe((validationForm) => {
        const taskId = validationForm.taskId;
        this.openValidationForm(taskId);
      });
    });
  }

  private openValidationForm(taskId: number) {
    const opts: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      size: 'lg',
    };
    const ref = this.modalService.open(ValidationFormAnswerModalComponent, opts);

    ref.componentInstance.taskId = taskId;
  }
}
